import {
  Box,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';

import { Close as CloseIcon } from '@mui/icons-material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CustomButton from '../../../../../components/General/CustomButton';
import GoogleMaps from '../../../../../components/Layout/Google/GoogleMaps';
import { ReduxState } from '../../../../../types';
import { filteredDevices } from '../../helpers';
import useStyles from '../../styles';
import useSensors from '../../../../../hooks/useSensors';
import useNodes from '../../../../../hooks/useNodes';

const AddDevicesFlowThirdStep = ({
  // setDeviceInfo,
  title,
  detailedInfoTitle,
  detailedInfo,
  handleCloseModal,
  handleStep,
  insertFunction,
  setCoordinates,
}: {
  title: string,
  detailedInfoTitle: string,
  detailedInfo: {
    [key: string]: string | number,
  },
  handleCloseModal: VoidFunction,
  handleStep: (step: 'firstStep' | 'secondStep' | 'thirdStep') => void,
  insertFunction: () => Promise<void>,
  setCoordinates: React.Dispatch<React.SetStateAction<{ lng: number, lat: number }[] | null>>,
}) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const { selectedFarm } = useSelector((state: ReduxState) => state.accountFarm);
  const { sensorNodeFilter } = useSelector((state: ReduxState) => state.farmSector);
  const { nodes } = useNodes(selectedFarm?.id ?? '');
  const { sensors } = useSensors(selectedFarm?.id ?? '');
  const allFarmDevices = [...nodes, ...sensors];
  const parsedInformation = Object.entries(detailedInfo).map(([label, value]) => ({
    label,
    value,
  }));

  const farmCoordinates = selectedFarm?.coordinates
    ? selectedFarm.coordinates.map(({ lat: farmLat, lng: farmLng }) => ({
      lat: typeof farmLat === 'string' ? parseFloat(farmLat) : farmLat,
      lng: typeof farmLng === 'string' ? parseFloat(farmLng) : farmLng,
    })) : null;

  return (
    <Box display='flex' flexDirection='column' flex='1'>
      <Box className={classes.uploadKMZModalHeader}>
        <Typography
          variant="h3"
          color="textPrimary"
          className={classes.uploadKMZModalHeaderTitle}
        >
          <span className={classes.activePageUnderlined}>
            {title}
          </span>
        </Typography>
        <IconButton onClick={handleCloseModal}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider className={classes.divider} />
      <Box className={classes.addDevicesFlowListTileAndTextContainer}>
        <Box className={classes.addDevicesFlowListTileContainer}>
          <Typography
            variant="h4"
          >
            {detailedInfoTitle}
          </Typography>
          {parsedInformation.map((info) => <Box key={info.label}>
            <Typography
              component='span'
              fontSize='12px'

            >
              {info.label}{': '}
            </Typography>
            <Typography
              component='span'
              fontSize='12px'
              fontWeight='bold'
            >
              {info.value}
            </Typography>
          </Box>)}
        </Box>
        <Box className={classes.typographyNodeTitleContainer}>
          <Typography
            variant='body2'
            className={classes.typographyNodeTitle}
          >
            Haz click en el mapa donde quieras poner el nodo. Una vez que hayas elegido el destino
            final de este, presiona agregar para finalizar el proceso.
          </Typography>
        </Box>

      </Box>
      <Divider className={classes.divider} />
      <Box border='1px solid black' flex='1'>
        <GoogleMaps
          farm={detailedInfo.Sector === '-' ? {
            id: selectedFarm?.id ?? '',
            coordinates: farmCoordinates,
            zoom: selectedFarm?.zoom ?? 18,
          } : {
            id: '',
            coordinates: [],
            zoom: selectedFarm?.zoom ?? 18,
          }}
          lat={selectedFarm?.center.lat ?? ''}
          lng={selectedFarm?.center.lng ?? ''}
          drawable='marker'
          polygons={selectedFarm?.sectors?.filter(
            (sector) => sector.wiseconnId === detailedInfo.Sector,
          ) ?? []}
          markers={filteredDevices(allFarmDevices, sensorNodeFilter)}
          setCoordinates={setCoordinates}
        />
      </Box>
      <Box className={classes.addPolygonButtonContainer}>
        <Box className={classes.singleButtonContainer} marginRight='20px'>
          <CustomButton
            buttonText='anterior'
            onClick={() => handleStep('secondStep')}
            disabled={isLoading}
          />
        </Box>
        <Box className={classes.singleButtonContainer}>
          <CustomButton
            buttonText='Finalizar'
            onClick={async () => {
              setIsLoading(true);
              try {
                await insertFunction();
              } finally {
                setIsLoading(false);
              }
            }}
            color='lightBlue'
            disabled={isLoading}
            isLoading={isLoading}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default AddDevicesFlowThirdStep;
